import { CancelToken } from "apisauce";
import React, { useState, useEffect } from "react";
import { createContext } from "react";

import { SessionStorage } from "../utils";

export const StorageContext = createContext({});

export default function StorageProvider({ children }: any): JSX.Element {
  const [data, setData] = useState<any>({});
  const [isLogged, setIsLogged] = useState<boolean>(false);
  const [cancelToken, setCancelToken] = useState<any>(CancelToken.source());
  const [dataAp, setDataAp] = useState<any>(null);
  useEffect(() => {
    const token = SessionStorage.getItem("token");
    if (token) {
      setIsLogged(true);
    }
  }, [setIsLogged]);

  function logOut() {
    removeData("token");
    SessionStorage.removeItem("token");

    setIsLogged(false);
  }

  function addData(key?: any, value?: any) {
    setData((state?: any) => ({ ...state, [key]: value }));
  }

  function removeData(key?: any) {
    setData((state?: any) => {
      const newState = state;
      delete newState[key];
      return newState;
    });
  }

  function getData(key?: any) {
    return data[key];
  }

  return (
    <StorageContext.Provider
      value={{
        addData,
        removeData,
        getData,
        isLogged,
        setIsLogged,
        logOut,
        cancelToken,
        setCancelToken,
        dataAp,
        setDataAp,
      }}
    >
      {children}
    </StorageContext.Provider>
  );
}
